import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DataLayerAddToCart = props => {
  const datalayerAddToCartHandler = event => {
    let validClasses = ["ter-ecommerce-card__button", "product-detail-page__product-information--add-to-cart__button"]

    if (containsValidTargetClass(validClasses, event?.target?.classList)) {
      let element = event.target
      const eCommerceCardElement =
        element?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode
      const eyebrow = eCommerceCardElement
        ?.querySelector(".ter-ecommerce-card__eyebrow")
        ?.innerHTML.toLowerCase()
      const header = eCommerceCardElement
        ?.querySelector(".ter-ecommerce-card__header")
        ?.innerHTML.toLowerCase()
      const price = eCommerceCardElement
        ?.querySelector(".ter-ecommerce-card__price-current")
        ?.innerHTML?.split(" ")[0]
        ?.substring(1)
      const currency = eCommerceCardElement
        ?.querySelector(".ter-ecommerce-card__price-current")
        ?.innerHTML?.split(" ")[1]

      const item_brand = `${eyebrow}`
      const item_name = `${eyebrow} ${header}`

      const cart = []

      if (element?.className?.includes("ter-ecommerce-card__button")) {
        cart.push({
          item_id: "",
          item_name: item_name,
          item_brand: item_brand,
          item_category: "",
          price: price,
          currency: currency,
          quantity: "",
          coupon: "",
          rating: "",
          rating_quantity: "",
          sku: "",
        })
      } 
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          item_list_name: "related products",
          item_list_id: "L001",
          items: cart,
        },
      })     
    }
  }
  // add handler if relevant listener elem exists
  let query = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query = document?.querySelectorAll(".ter-button").length > 0
  }
  useClickListener(datalayerAddToCartHandler, query)
}

export default DataLayerAddToCart
